import { Link } from "react-router-dom";
import styled from "styled-components";
import { T } from "../theme";
import { ECOSYSTEM } from "../data/ecosystem";

const Bar = styled.footer`
  border-top: 1px solid ${T.border};
  background: ${T.card};
  padding: clamp(40px, 5vw, 60px) clamp(16px, 5vw, 40px) 28px;
`;

const Inner = styled.div`
  max-width: 1080px;
  margin: 0 auto;
`;

const Top = styled.div`
  display: grid;
  grid-template-columns: 1.4fr 1fr 1fr;
  gap: 32px;
  padding-bottom: 32px;
  border-bottom: 1px solid ${T.border};

  @media (max-width: 760px) {
    grid-template-columns: 1fr 1fr;
    gap: 26px;
  }
  @media (max-width: 460px) {
    grid-template-columns: 1fr;
  }
`;

const Brand = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media (max-width: 760px) { grid-column: 1 / -1; }
`;

const BrandName = styled.p`
  font-size: 1rem;
  font-weight: 800;
  color: ${T.text};
  letter-spacing: -0.01em;
`;

const Tagline = styled.p`
  font-size: 0.82rem;
  color: ${T.muted};
  line-height: 1.6;
  max-width: 360px;
`;

const Social = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 4px;
  flex-wrap: wrap;
`;

const SocialLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 0.75rem;
  font-weight: 600;
  color: ${T.muted2};
  padding: 6px 11px;
  border: 1px solid ${T.border};
  border-radius: 8px;
  transition: border-color 0.12s, color 0.12s;
  &:hover { border-color: var(--purple); color: var(--purple); }
`;

const Col = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 11px;
`;

const ColTitle = styled.p`
  font-size: 0.68rem;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: ${T.muted2};
  margin-bottom: 3px;
`;

const FLink = styled.a`
  font-size: 0.82rem;
  color: ${T.muted};
  transition: color 0.12s;
  &:hover { color: var(--purple); }
`;

const Bottom = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding-top: 22px;
`;

const Copy = styled.p`
  font-size: 0.74rem;
  color: ${T.muted2};
`;

const BottomLinks = styled.div`
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
`;

export default function Footer() {
  return (
    <Bar>
      <Inner>
        <Top>
          <Brand>
            <BrandName>Guebly Holding</BrandName>
            <Tagline>
              Holding de tecnologia com 6 empresas e 25+ produtos em construção.
              100% remoto, cultura de execução real e alta performance.
            </Tagline>
            <Social>
              <SocialLink href="https://www.linkedin.com/company/guebly" target="_blank" rel="noreferrer" aria-label="LinkedIn da Guebly (abre em nova aba)">
                <span aria-hidden="true">in</span> LinkedIn
              </SocialLink>
              <SocialLink href="https://www.instagram.com/guebly" target="_blank" rel="noreferrer" aria-label="Instagram da Guebly (abre em nova aba)">
                <span aria-hidden="true">◈</span> Instagram
              </SocialLink>
              <SocialLink href="mailto:pessoas@guebly.com.br" aria-label="Enviar e-mail para a Guebly">
                <span aria-hidden="true">✉</span> E-mail
              </SocialLink>
            </Social>
          </Brand>

          <Col aria-label="Navegação de carreiras">
            <ColTitle>Carreiras</ColTitle>
            <FLink as={Link} to="/#empresas">Nossas empresas</FLink>
            <FLink as={Link} to="/#vagas">Vagas abertas</FLink>
            <FLink as={Link} to="/#beneficios">Cultura & benefícios</FLink>
            <FLink as={Link} to="/#processo">Processo seletivo</FLink>
            <FLink as={Link} to="/banco-de-talentos">Banco de talentos</FLink>
            <FLink as={Link} to="/acompanhar">Minha candidatura</FLink>
          </Col>

          <Col aria-label="Empresas do grupo">
            <ColTitle>O grupo</ColTitle>
            {ECOSYSTEM.slice(0, 5).map((c) => (
              <FLink as={Link} key={c.slug} to="/#empresas">{c.name}</FLink>
            ))}
            <FLink href="https://www.guebly.com.br" target="_blank" rel="noreferrer">Site institucional ↗</FLink>
          </Col>
        </Top>

        <p style={{ fontSize: 11, lineHeight: 1.7, color: "var(--muted2)", opacity: 0.85, marginTop: 18, maxWidth: 760 }}>
          Contratação: <strong>Guebly LTDA</strong> · CNPJ 63.316.501/0001-00 e <strong>Guebly Contábil LTDA</strong> · CNPJ 66.801.020/0001-70.
          {" "}Administração do grupo: <strong>Guebly Holding LTDA</strong> · CNPJ 64.938.092/0001-38 (governança — não contrata).
        </p>

        <Bottom>
          <Copy>© {new Date().getFullYear()} Guebly Holding. Todos os direitos reservados.</Copy>
          <BottomLinks role="navigation" aria-label="Links legais">
            <FLink href="https://www.guebly.com.br/politica-de-privacidade" target="_blank" rel="noreferrer">Privacidade</FLink>
            <FLink href="https://www.guebly.com.br/cookies" target="_blank" rel="noreferrer">Cookies</FLink>
          </BottomLinks>
        </Bottom>
      </Inner>
    </Bar>
  );
}
